<template>
  <div class="inner-content">
    <tl-select
      class="margintop-20"
      label="Document Category"
      labelText="docName"
      :placeholder="`select`"
      :options="documentTypes"
      :v-model="formData.docType"
      @change="(val)=>formData.docType = val.id"
      name="documentCategory"
      v-validate="'required'"
      :classname="errors.has('documentCategory')"
      :errormsg="errors.first('documentCategory')"
    />
    <search-dropdown :employeeData="employeeData" @empselected="(emp)=>selectedEmp(emp)" />
    <div class="filters filter-margin-bot margintop-2p">
      <tl-select
        labelText="name"
        label="Paygroup"
        :placeholder="`select`"
        :options="payGroups"
        :reduce="empFilter => `${empFilter.name}`"
        @change="(pg)=>formData.payGroupList[pg.name]='pgName'"
      />
      <tl-select
        labelText="name"
        label="Criteria"
        :placeholder="`select`"
        :options="payGroups"
        :reduce="empFilter => `${empFilter.name}`"
        @change="(pg)=>formData.payGroupList[pg.name]='pgName'"
      />
      <tl-select
        labelText="name"
        label="Sub-Criteria"
        :placeholder="`select`"
        :options="payGroups"
        :reduce="empFilter => `${empFilter.name}`"
        @change="(pg)=>formData.payGroupList[pg.name]='pgName'"
      />
    </div>
    <btn text="Apply Filters" type="secondary" class="apply-filter-btn" @change="filter"></btn>
    <hr />
    <div class="col-2 groupBlock d-completed margintop-2p">
      <div class="row groupName">
        <div class="col-5 count">100</div>
        <div class="col-5 label-text">Employees Selected</div>
      </div>
    </div>
     <footer>
      <bottom-action-container class="position-fixed">
        <btn-grp slot="end">
          <btn text="Cancel" type="secondary" class @click="cancel"></btn>
          <btn text="Download" type="primary" class @click="download"></btn>
        </btn-grp>
      </bottom-action-container>
    </footer>
  </div>
</template>
<script>
import SearchDropdown from "@/components/TlSearchDropdown.vue";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    SearchDropdown
  },
  computed: {
    ...mapState({
      payGroups: state => state.dashboard.payroll.monthlypayroll.payGroup.data
    })
  },
  data() {
    return {
      formData: {},
      documentTypes: [],
      employeeData: [
        {
          code: "TL001",
          name: "Nelle Foster",
          designation: "Designer",
          department: "KJHG",
          costcenter: "1500000",
          reportingmgr: "Owen Pearson",
          nooflop: "4",
          lopdates: "06/05/2019, 07/05/2019, 08/05/2019",
          noofrlop: "1",
          rlopdates: "06/05/2019"
        },
        {
          code: "TL002",
          name: "Derrick Perry",
          designation: "Designer",
          department: "KJHG",
          costcenter: "1500000",
          reportingmgr: "Owen Pearson",
          nooflop: "4",
          lopdates: "06/05/2019, 07/05/2019, 08/05/2019",
          noofrlop: "1",
          rlopdates: "06/05/2019"
        },
        {
          code: "TL003",
          name: "Lucas Singleton",
          designation: "Designer",
          department: "KJHG",
          costcenter: "1500000",
          reportingmgr: "Owen Pearson",
          nooflop: "4",
          lopdates: "06/05/2019, 07/05/2019, 08/05/2019",
          noofrlop: "1",
          rlopdates: "06/05/2019"
        },
        {
          code: "TL004",
          name: "Nelle Foster",
          designation: "Designer",
          department: "KJHG",
          costcenter: "1500000",
          reportingmgr: "Owen Pearson",
          nooflop: "4",
          lopdates: "06/05/2019, 07/05/2019, 08/05/2019",
          noofrlop: "1",
          rlopdates: "06/05/2019"
        },
        {
          code: "TL001",
          name: "Nelle Foster",
          designation: "Designer",
          department: "KJHG",
          costcenter: "1500000",
          reportingmgr: "Owen Pearson",
          nooflop: "4",
          lopdates: "06/05/2019, 07/05/2019, 08/05/2019",
          noofrlop: "1",
          rlopdates: "06/05/2019"
        }
      ]
    };
  },
  activated() {
    if (this.$_.isEmpty(this.payGroups)) this.act_fetchPaygroups();
  },
  methods: {
    ...mapActions({
      act_fetchPaygroups: "dashboard/payroll/monthlypayroll/payGroup/fetchAll"
    }),
    download(){

    },
    cancel(){

    },
    filter(){
        
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/scss/dashboard/_variables.scss"; // Common
@import "@/scss/dashboard/content/_section.scss"; // Content Section
.filter-margin-bot {
  margin-bottom: 1.4%;
}
// .position-fixed{
//   position: fixed;
// }
.apply-filter-btn {
  margin: 2.1% 0 2.3% 0;
}
.margintop-2p{
    margin-top: 2%;
}
.header-space {
  margin: 18px 0px 10px 0px;
}
.radio-margin-bot {
  margin-bottom: 3.4%;
}
hr {
  background: #ebebeb;
}
.search-width{
  width: 410px !important;
    position: relative;
    max-width: 410px !important;
}
.groupName {
  .count {
    color: $color-secondary;
    font-size: 30px;
    font-weight: 600;
  }
  .label-text {
    font-size: 14px;
    font-weight: 500;
  }
}
</style>